import { useAPI } from 'contexts/APIProvider'
import { useSnackBarAlert } from 'contexts/SnackBarAlertProvider'
import UserFormError from 'errors/UserFormError'
import React from 'react'
import { useNavigate, useParams } from 'react-router'
import { UserForm } from 'types/interfaces'
import AdminUserForm from './form'
import update from 'immutability-helper'

const AdminUserUpdate: React.FC = () => {
    const params = useParams()
    const { api } = useAPI()
    const { showAlert} = useSnackBarAlert()
    const navigate = useNavigate()
    const [form, setForm] = React.useState<UserForm>({})
    const [error, setError] = React.useState<UserFormError>()
    const [loading, setLoading] = React.useState<boolean>(false)

    const userId = React.useMemo(() => Number(params.userId), [params.userId]) 

    const updateForm = React.useCallback((name: string, value: any) => {
        setForm(update(form, { [name]: { $set: value } }))
        if (error) setError(update(error, { [name]: { $set: [] } }))
      }, [error, form])

    const submit = React.useCallback(async () => {
        try {
            setLoading(true)
            await api.updateUser(userId, form)
            showAlert('success', 'User updated successfully!')
            navigate(-1)
        } catch (error) {
            if (error instanceof UserFormError) {
                setError(error)
            }
        } finally {
            setLoading(false)
        }
    }, [form, api, showAlert, navigate, userId])

    const prepopulate = React.useCallback(async () => {
        try {
            const user = await api.getUser(userId)
            setForm({
                email: user.email,
                password: '',
                first_name: user.first_name,
                last_name: user.last_name,
                practice_ids: user.practice_ids,
                practice_group_ids: user.practice_group_ids,
            })
        } catch (error) {
            console.error(error)
        }
    }, [api, userId])

    React.useEffect(() => {
        prepopulate()
    }, [prepopulate])
    
    return (
        <AdminUserForm title='Update User' 
            form={form} 
            updateForm={updateForm} 
            submit={submit} 
            loading={loading} 
            error={error} 
        />
    )
}

export default AdminUserUpdate